export default {
  data() {
    return {
      windowSizeMixin: {
        width: null,
        height: null
      }
    }
  },
  computed: {
    mdOrDown() {
      return this.windowSizeMixin.width < process.env.VUE_APP_WINDOW_SIZE_MD;
    },
    smOrDown() {
      return this.windowSizeMixin.width < process.env.VUE_APP_WINDOW_SIZE_SM;
    },
    xsOnly() {
      return this.windowSizeMixin.width < process.env.VUE_APP_WINDOW_SIZE_XS;
    },
  },
  methods: {
    windowSizeHandleMixin() {
      this.windowSizeMixin.width = window.innerWidth
      this.windowSizeMixin.height = window.innerHeight
    }
  },
  created() {
    window.addEventListener("resize", this.windowSizeHandleMixin)
    this.windowSizeHandleMixin()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.windowSizeHandleMixin)
  }
}
